import styled from 'styled-components';
import { fontTitle } from 'Styles/fonts';

export const Title = styled.h1`
  ${fontTitle(20)};
  padding: 0;
  margin: 0;
  text-align: center;
  line-height: 4rem;
  vertical-align: middle;
  color: var(--foreground);
  text-transform: none;
`;

export const FixedComponent = styled.div`
  position: absolute;
  top: 12px;
  ${({ side }) =>
    side === 'left'
      ? `
      left: 0;
      margin-left: -16px;`
      : `
      right: 0;
      margin-right: -16px;`}
`;

export const BottomComponent = styled.div`
  margin-bottom: 24px;
`;

export const DialogHeader = styled.div`
  position: relative;
  ${({ withDivider }) =>
    withDivider && 'border-bottom: 1px solid var(--border);'}
  min-height: ${({ withCollapse }) => !withCollapse && '64px'};
  margin: 0 16px;
  text-align: center;
`;
